import api from "./Api";

class OrderingOrdersService {
  GetStores() {
    return api
      .get("/v1/OrderingOrders/stores")
      .then((response) => response.data);
  }

  GetOrders(params) {
    return api
      .get("/v1/OrderingOrders", { params })
      .then((response) => response.data);
  }

  GetOrder(orderId) {
    return api
      .get(`/v1/OrderingOrders/${orderId}`)
      .then((response) => response.data);
  }
}

export default new OrderingOrdersService();
